import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';
import { adminRoles, adminStatuses } from './admins.types';

export const adminsFiltersSchema = z
  .object({
    admins: z.array(z.string()).catch([]),
    status: z.array(z.enum(adminStatuses)).catch([]),
    role: z.array(z.enum(adminRoles)).catch([]),
    roleIds: z.array(z.string()).catch([]),
    companies: z.array(z.string()).catch([]),
    search: z.string().catch(''),
    listVariant: z.enum(adminRoles).catch('hrAdmin'),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
